<script type="text/ecmascript-6">
    import DesignerQuestionGlassBackingDesign from "../DesignerQuestionGlassBackingDesign.vue";
    import SynsealTileQuestion from "../mixin/synseal/TileQuestion.vue";

    export default {
        mixins: [
            DesignerQuestionGlassBackingDesign,
            SynsealTileQuestion,
        ],
    }
</script>
